import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlanoResponse } from 'app/shared/models/ei-models';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlanoService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Plano/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  getAll(loader = true): Observable<Array<PlanoResponse>> {
    return this.httpClient.get<Array<PlanoResponse>>
      (this.controllerEndpoint, { headers: this.getHeader(loader) });
  }
}